module.exports = __webpack_public_path__ + "static/media/red-header.c1e0674d.png";